export default __webpack_public_path__ + "static/1.2_IT-83b1c604145da7b702ee2625c1712c74.webp";